module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item",
    attrs: {
      "loading": "loading"
    }
  }, [_c('section', {
    staticClass: "product-item-content"
  }, [_c('Tabs', {
    attrs: {
      "animated": false
    },
    model: {
      value: (_vm.activeIndex),
      callback: function($$v) {
        _vm.activeIndex = $$v
      },
      expression: "activeIndex"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "拼团信息",
      "name": "0"
    }
  }, [(_vm.modelLoaded) ? _c('rule', {
    attrs: {
      "mode": _vm.mode,
      "setDefaultValue": _vm.setDefaultValue,
      "setModel": _vm.setModel,
      "model": _vm.model,
      "extra": _vm.extra
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "产品基本信息",
      "name": "1",
      "disabled": !_vm.modelLoaded
    }
  }, [_c('info', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLoaded),
      expression: "modelLoaded"
    }],
    ref: "info",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "validate": false,
      "mode": "readonly",
      "extra": _vm.extra,
      "loaded": _vm.modelLoaded,
      "is-tuan": _vm.mode !== 'readonly'
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "购买使用说明",
      "name": "2",
      "disabled": !_vm.modelLoaded
    }
  }, [_c('instruction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLoaded),
      expression: "modelLoaded"
    }],
    ref: "instruction",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "validate": false,
      "extra": _vm.extra,
      "mode": "readonly",
      "is-tuan": _vm.mode !== 'readonly',
      "loaded": _vm.modelLoaded
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "价格/库存/有效期",
      "name": "3",
      "disabled": !_vm.modelLoaded
    }
  }, [_c('price', {
    ref: "price",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "extra": _vm.extra,
      "mode": "readonly",
      "is-tuan": _vm.mode !== 'readonly'
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLoaded),
      expression: "modelLoaded"
    }],
    staticClass: "row button-area"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-2"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.onlineLoading,
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [(!_vm.saveLoading) ? _c('span', [_vm._v("保存")]) : _c('span', [_vm._v("保存中...")])]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.saveLoading,
      "loading": _vm.onlineLoading
    },
    on: {
      "click": _vm.saveAndOnline
    }
  }, [(!_vm.onlineLoading) ? _c('span', [_vm._v("保存并上线")]) : _c('span', [_vm._v("保存中...")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4f899e4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/tuan/Main.vue
// module id = 591
// module chunks = 0